import { Component, Input } from '@angular/core';
import { SummaryChart } from '../../models/data-chart';

@Component({
  selector: 'pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
  standalone: false
})
export class PieChartComponent {
  @Input() chart: SummaryChart;
  chartOptions: any = {
    animation: false,
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false
      }
    }
  };

  get looseDatasets(): any[] { return this.chart.datasets; }
}
